<template lang="html">

 <div class="contacto--view contacto">


   <section class="intro-xs">
    <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
      <div class="container-text">
        <h2 class="title title-52">{{$t('enlaces.textos.contacto')}}</h2>
      </div>
    </div>
  </section>

  <section class="at-cliente pad-sec">
    <div class="container flex wrap">
      <div id="solicita-catalogo">
        <h2 class="title title-36">{{$t('contacto.titulo')}}</h2>
        <formulario></formulario>
      </div>
    </div>
  </section>

  <section class="sucursales-info">
    <div class="direccion container flex row-reserve justify-start">
      <div class="col-50">
        <div class="direcciones--container">
          <div class="scroller">
            <div class="element" :data="key" v-for="(e, key) in $t('contacto.delegaciones')">
              <h3 class="title title-26" v-html="$t('contacto.direccion.titulo')"></h3>
              <p v-html="$t('contacto.direccion.direccion')"></p>
              <p v-html="$t('contacto.direccion.telefono')"></p>
              <p v-if="!!e.fax" v-html="$t('contacto.direccion.fax')"></p>
              <p v-html="$t('contacto.direccion.email')"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section class="mapa">
    <GmapMap :center="coords" :zoom="15" id="map">
      <GmapMarker :position="coords"/>
    </GmapMap>
  </section>



  <section class="work-us sec-foto metal pad-sec">
    <div class="container waypoints flex row-reserve justify-start" data="fadeInLeft">
      <div class="col-50">
        <router-link :to="$t('enlaces.trabaja_con_nosotros')"></router-link>
        <h3 class="title title-52">{{$t('enlaces.textos.trabaja_con_nosotros')}}</h3>
        <p>{{$t('trabaja_con_nosotros.texto')}}</p>
        <p class="go">{{$t('trabaja_con_nosotros.boton')}}<i class="fa fa-long-arrow-right" aria-hidden="true"></i></p>
      </div>
    </div>
  </section>

  <otras-secciones :data="['productos','tecnologia']"></otras-secciones>

</div>

</template>

<script lang="js">

  import Formulario from '@/components/view-parts/contacto/formulario';

  import Otras_Secciones from '@/components/parts/acceso-a-secciones';

  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'

  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyAttpTK5iehbKQax7nKCYv37uyRtuGoYWk',
    }
  })


  export default  {
    name: 'contacto',
    props: [],
    mounted() {

    },
    data() {
      return {
        site_coords : {
          espana : {lat: 39.0034405, lng: -1.8193903999999748},
          rusia : {lat: 55.526836777138584, lng: 37.448515283993856},
          uk : {lat: 52.71733313455952, lng: -2.4637021408825603},
          mexico : {lat:19.443061205605765, lng: -99.19093869999995},
          brasil : {lat: -23.515094656909923, lng:-46.744552150000004},
        },
        coords : {lat: 39.0034405, lng: -1.8193903999999748}
      }
    },
    methods: {
     setMapa: function(value){
      let move = $(".direcciones--container").height();
      let position = $(`.element[data="${value}"]`).index() * move;
      $(".scroller").attr('style', `transform:translateY(-${position}px)`);
      this.coords = this.site_coords[value];
      
    }
  },
  components: {
    'formulario':Formulario,
    'otras-secciones' : Otras_Secciones
  }
}
</script>

<style scoped  >
.element {
  height: 210px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  -webkit-justify-content: center;
}

.element h3{
  margin-top: 0;
}

.scroller{
  will-change:transform;
  transition: .4s;
}

.direcciones--container{
  height: 210px;
  overflow: hidden;
}

.enlaces_delegaciones span{
  padding-right: 10px;
  margin-right: 10px;
  border-right: 1px solid white;
}

.enlaces_delegaciones span:last-of-type{
  border-right: none;
  margin-right: 0;
  padding-right: 0;
}

.js-show-pais{
  cursor: pointer;
}
#solicita-catalogo{
  width: 100%;
}
.sucursales-info{
  background-color: #e6ecf1;
  color: white;
  padding: 30px 0;
  padding-top: 60px;
  position: relative;
}
.direccion .col-50{
  width: 100%;
  text-align: left;
}
.sucursales-info .justify-start{
 background-color: #054279;
 max-width: 460px;
 padding: 30px;
 text-align: left;
 position: absolute;
 left: 50px;
 z-index: 6;
 top: 0px;
}

@media only screen and (max-width: 1024px) {
  .sucursales-info .justify-start{
    background-color: #054279;
    max-width: 100%;
    padding: 30px;
    text-align: left;
    position: relative;
    left: 0;
    z-index: 6;
    top: 0px;
  }
  .sucursales-info{
    padding: 0;
  }
}


@media screen and (max-width: 760px){

  .enlaces_delegaciones span{
    width: 100%;
    display: inline-block;
    border-right: 0;
  }  

  .direcciones--container{
    height: 260px;
  }

  .element{
    height: 260px;
  }

}


</style>



// WEBPACK FOOTER //
// src/components/views/contacto.vue